import axios, {AxiosResponse} from 'axios'
import {recurrenceReportsQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const REPORTS_URL = `${API_URL}/kpi/reports`

const getRecurrenceReports = (query: string): Promise<recurrenceReportsQueryResponse> => {
  return axios
    .get(`${REPORTS_URL}/recurrence?${query}`)
    .then((d: AxiosResponse<recurrenceReportsQueryResponse>) => d.data)
}

const downloadServerFile = async (
  filter: string | undefined
): Promise<{message: string; id: number} | void> => {
  var filterAdjust = filter !== undefined ? `?${filter}` : ''

  const response = await axios({
    url: `${REPORTS_URL}/recurrence/export${filterAdjust}`,
    method: 'GET',
    responseType: 'blob',
  })

  const contentType = response.headers['content-type'] ?? ''

  if (contentType.includes('application/json')) {
    const text = await (response.data as Blob).text()
    return JSON.parse(text) as {message: string; id: number}
  }

  const href = URL.createObjectURL(response.data)
  const link = document.createElement('a')
  link.href = href
  link.setAttribute('download', 'Relatorio_recorrente.xlsx')
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(href)
}

export {getRecurrenceReports, downloadServerFile}
